._new-block-button-container_maqeu_1 {
  width: inherit;
  height: 60px;
  display: flex;
  justify-content: center;
  border-top: solid thin #dfe5eb; }
